<template>
  <div class="header-responsive">
    <v-sheet class="overflow-hidden">
      <v-container class="fill-height">
        <v-btn
          class="pa-0"
          x-large
          depressed
          color="white"
          @click.stop="drawer = !drawer"
        >
          <v-icon>{{ icons.menu }}</v-icon>
        </v-btn>
        <div class="middle-title">
          <h2 class="title-size">
            <span class="title-blue">InstaCares</span>
          </h2>
        </div>
      </v-container>

      <v-navigation-drawer height="100vh" v-model="drawer" absolute temporary>
        <router-link :to="authenticated ? '/inicio' : '/'" link>
          <v-list-item class="pa-4" style="justify-content: center">
            <v-img
              src="@/assets/img/logo4.png"
              max-height="120"
              max-width="120"
              contain
            ></v-img>
          </v-list-item>
        </router-link>

        <v-divider></v-divider>
        <!-- START DRAWER WHEN LOGGED -->
        <v-list nav>
          <template v-for="(item, idx) in drawerItems">
            <template v-if="item.sublinks">
              <v-list-group :prepend-icon="item.icon" :key="idx">
                <template v-slot:activator>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </template>
                <template v-if="item.title == 'Meu Perfil'">
                  <PerfilMenu responsive></PerfilMenu>
                </template>
                <template v-else>
                  <v-list-item
                    v-for="(subitem, idy) in item.sublinks"
                    :to="subitem.path"
                    link
                    :key="idx + '-' + idy"
                  >
                    <v-list-item-title>{{ subitem.title }}</v-list-item-title>
                    <v-list-item-action>
                      <v-icon>{{ subitem.icon }}</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </template>
              </v-list-group>
            </template>
            <template v-else>
              <v-list-item :key="idx" :to="item.path" link>
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </template>
        </v-list>
        <!-- START BUTTON LOGOUT WHEN LOGGED -->
        <template v-if="this.$store.state.logged" v-slot:append>
          <v-btn
            block
            dark
            color="primary"
            depressed
            x-large
            @click="processHeaderLink"
            >Sair</v-btn
          >
        </template>
        <!-- END BUTTON LOGOUT WHEN LOGGED -->
      </v-navigation-drawer>
    </v-sheet>
  </div>
</template>

<script>
import PerfilMenu from '@/components/menus/PerfilMenu.vue'
import {
  mdiMenu,
  mdiLogin,
  mdiMagnify,
  mdiGift,
  mdiAlert,
  mdiCheckAll,
  mdiMedicalBag,
  mdiInformationVariant,
  mdiAt,
  mdiHelpCircle,
  mdiDomain,
  mdiMessageReply,
  mdiClipboardList,
  mdiClipboardCheck,
  mdiClipboard,
  mdiCalendarToday,
  mdiCalendarCheck,
  mdiCalendarPlus,
  mdiAccount,
  mdiAccountMultiple,
  mdiDatabase,
  mdiPencil,
  mdiCalendar,
  mdiTicket,
  mdiShield
} from '@mdi/js'

export default {
  components: { PerfilMenu },
  data: () => ({
    icons: {
      menu: mdiMenu
    },
    drawer: false,
    right: null,
    publicLinks: [
      { title: 'Entrar/Cadastrar', path: '/login', icon: mdiLogin },
      //{ title: "Funcionalidades", path: "/services", icon: "fas fa-laptop-medical" },
      { title: 'Vantagens', path: '/vantagens', icon: mdiCheckAll },
      { title: 'Serviços', path: '/saibamais', icon: mdiMedicalBag },
      { title: 'Sobre nós', path: '/sobre', icon: mdiInformationVariant },
      { title: 'Contato', path: '/contato', icon: mdiAt },
      {
        title: 'Perguntas Frequentes',
        path: '/faq',
        icon: mdiHelpCircle
      },
      {
        title: 'Para sua Empresa',
        path: '/contatoEmpresa',
        icon: mdiDomain
      }
    ],
    profissionalLinks: [
      { title: 'Mensagens', path: '/mensagens', icon: mdiMessageReply },
      {
        title: 'Prontuários Pendentes',
        path: '/prontuarios_pendentes',
        icon: mdiClipboardList
      },
      {
        title: 'Informações de Atendimentos',
        path: '/informacao_atendimento',
        icon: mdiClipboard
      },
      {
        title: 'Agendamentos',
        path: '',
        icon: mdiCalendarToday,
        sublinks: [
          {
            title: 'Realizados',
            path: '/agendamentos_realizados',
            icon: mdiCalendarCheck
          },
          {
            title: 'Programados',
            path: '/atendimentos_agendados',
            icon: mdiCalendarPlus
          }
        ]
      },
      {
        title: 'Meu Perfil',
        path: '',
        icon: mdiAccount,
        sublinks: [
          { title: 'Visualizar', path: '/perfil', icon: mdiAccount },
          {
            title: 'Trocar Perfil',
            path: '/signin',
            icon: mdiAccountMultiple
          }
        ]
      }
    ],
    clientLinks: [
      { title: 'Mensagens', path: '/mensagens', icon: mdiMessageReply },
      {
        title: 'Agendar Serviço',
        path: '/agendamento',
        icon: mdiClipboardCheck
      },
      {
        title: 'Prontuários',
        path: '/prontuarios_pendentes',
        icon: mdiClipboard
      },
      //{ title: "Armazenamento", path: "/armazenamento", icon: mdiDatabase },
      {
        title: 'Agendamentos',
        path: '',
        icon: mdiCalendarToday,
        sublinks: [
          {
            title: 'Realizados',
            path: '/agendamentos_realizados',
            icon: mdiCalendarCheck
          },
          {
            title: 'Programados',
            path: '/atendimentos_agendados',
            icon: mdiCalendarPlus
          }
        ]
      },
      {
        title: 'Meu Perfil',
        path: '',
        icon: mdiAccount,
        sublinks: [
          { title: 'Editar', path: '/perfil', icon: mdiPencil },
          {
            title: 'Trocar Perfil',
            path: '/selecionarperfil',
            icon: mdiAccountMultiple
          }
        ]
      }
    ],
    adminLinks: {
      title: 'Administrativo',
      path: '',
      icon: mdiShield,
      sublinks: [
        {
          title: 'Usuários',
          path: '/admin/usuarios',
          icon: mdiAccountMultiple
        },
        {
          title: 'Agendamentos',
          path: '/admin/agendamentos',
          icon: mdiCalendar
        },
        {
          title: 'Serviços',
          path: '/admin/services',
          icon: mdiClipboardCheck
        },
        {
          title: 'Cupons',
          path: '/admin/cupom',
          icon: mdiTicket
        },
        {
          title: 'Termos',
          path: '/admin/uploadEULA',
          icon: mdiDatabase
        }
      ]
    }
  }),

  mounted() {
    this.adminLinksMode(this.adminMode)
  },

  methods: {
    processHeaderLink() {
      this.$store.commit('resetState')
      this.$router.push('/')
    },

    adminLinksMode(newValue) {
      if (newValue) {
        this.profissionalLinks.push(this.adminLinks)
        this.clientLinks.push(this.adminLinks)
      } else {
        if (
          this.profissionalLinks[this.profissionalLinks.length - 1].title ===
            'Administrativo' ||
          this.clientLinks[this.clientLinks.length - 1].title ===
            'Administrativo'
        ) {
          this.profissionalLinks.pop()
          this.clientLinks.pop()
        }
      }
    }
  },

  computed: {
    userType: function() {
      return this.$store.getters.getUserType
    },
    authenticated: function() {
      return this.$store.getters.isPerfilSelected
    },
    adminMode: function() {
      return this.$store.getters.getAdminAuthentication.token ? true : false
    },
    drawerItems: function() {
      if (this.authenticated) {
        return this.userType == 'profissional'
          ? this.adminMode
            ? this.profissionalLinks
            : this.profissionalLinks
          : this.adminMode
          ? this.clientLinks
          : this.clientLinks
      } else return this.publicLinks
    }
  },

  watch: {
    adminMode(newValue) {
      this.adminLinksMode(newValue)
    }
  }
}
</script>

<style scoped>
.middle-title {
  position: absolute;
  left: 35vw;
}
.header-responsive {
  z-index: 99;
}
</style>
